import { getQueryObjectFromObject as c } from "@partoohub/utils";
import { ApiResourceBaseClass as n } from "./baseApiCalls.js";
const i = "review_analytics";
class y extends n {
  async getMetrics(t, e, s) {
    const a = {
      dimensions: t,
      metrics: e.join(","),
      ...c(s, !1)
    }, { data: r } = await this.get(
      `${i}/metrics`,
      a
    );
    return r;
  }
  async downloadMetrics(t, e, s, a) {
    const r = {
      dimensions: a,
      metrics: t.join(","),
      email: e,
      ...c(s, !1)
    }, { data: o } = await this.get(
      `${i}/metrics/download`,
      r
    );
    return o;
  }
}
export {
  y as ReviewAnalytics
};
